export const environment = {
  production: true,
  apiUrl: 'https://api.webservices.carbonwhite.se/api',
  hmr: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts